import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'

interface TaskAction extends Action {
    payload: any
}

const { onRequest, onSuccess, onFailure } = rootActions.dataImport.list

function* listSagaTask({ payload }: TaskAction) {
    try {
        const params: any = {
            ...(payload?.pagination || {}),
            addPresignedURL: true,
            sort: ['-createdAt']
        }
        if (payload?.query) {
            params.query = payload?.query
        }
        if (payload?.projection) {
            params.projection = payload?.projection
        }
        const response = yield axios.get(`/companies/imports`, {
            params
        })
        if (response.success) {
            yield put(onSuccess(response.result))
            yield put(payload?.sagaCB?.onSuccess(response.result))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* listSaga(): any {
    yield takeLatest<TaskAction>(onRequest, listSagaTask)
}

export default listSaga
